import type { ReactNode } from './react';
import { mount } from './react';

export function createRoot(container: HTMLElement) {
  return { render(node: ReactNode) { mount(container, node); } };
}
